module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAtFBMVEUAAAD/AAD/VQD/gAD/mTPVgAD/gCv/jhz/lSv/iSfziy70hSz0iiv1hSn3hzD0ji30iyzwhy31jjH2jS70ji71ii/2jTH2jTD0jTD1jTD0jjH0jTDzjDH0jTH0jTD2jTHzjTH1jDDzizDzjDDzjTD0jTHzjDD0jTHzjTH0jTH0jDD0jDD0jDDzjTD0jTD0jTD0jTDzjTH0jTD0jTD1jTH0jTD0jTH0jTH1jTH0jTD0jTD0jTHpuLFrAAAAO3RSTlMAAQMEBQYGCQwNFhcYGSAtLjM0OEhMU1Vga3h5g4iLjZOVlquuuLvCx83P09jZ5Oju8fL09fj6+/z9/qeWHQwAAABpSURBVAgdBcEFAsJAAMCw4u56uLvLgPX//yKhGkJoAvUQAtmzHpMkdrqC9k+7dPReAZZ6SO2N+wDlly50DQAD1W8JADIPdQMATFXjHgCtyM9cLzkgfdJZ4aYTYKTPIkONGtTeOob8Vbd/71IREBa3J34AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x.png
// module id = Dsb9
// module chunks = 18